module.exports = __webpack_public_path__ + "img/banner2.d3cddb42.jpg";